import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PermissionRole, PermissionRoleStatus } from './permission-models';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import * as _ from 'lodash';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class PermissionRoleService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/permissionrole`;
  }

  getRoles(params: { [param: string]: any }): Observable<AutoTablePageableResponse<PermissionRole>> {
    return this.httpClient.get<AutoTablePageableResponse<PermissionRole>>(`${this._baseURL}s`, {
      params: params
    });
  }

  getRole(roleName: string): Observable<PermissionRole> {
    return this.httpClient.get<PermissionRole>(`${this._baseURL}/${roleName}`);
  }

  newRole(roleName: string, description: string): Observable<any> {
    return this.httpClient.post(`${this._baseURL}`, { roleName, description });
  }

  updateRole(roleName: string, description: string, status: PermissionRoleStatus): Observable<any> {
    return this.httpClient.put(`${this._baseURL}/${roleName}`, { description, status });
  }

  removeRole(roleName: string[] | string): Observable<any> {
    if (_.isArray(roleName)) {
      return this.httpClient.delete(`${this._baseURL}`, {
        params: {
          roleName: roleName,
        }
      });
    } else {
      return this.httpClient.delete(`${this._baseURL}/${roleName}`);
    }
  }

  recoverRole(roleName: string[] | string): Observable<any> {
    if (_.isArray(roleName)) {
      return this.httpClient.patch(`${this._baseURL}`, {}, {
        params: {
          roleName: roleName,
          status: PermissionRoleStatus.Normal
        }
      });
    } else {
      return this.httpClient.patch(`${this._baseURL}/${roleName}`, {}, {
        params: {
          status: PermissionRoleStatus.Normal
        }
      });
    }
  }

  grantPermissionToRole(roleName: string, url: string | string[]): Observable<any> {
    if (!_.isArray(url)) {
      /**
       * url in the route should encode twice for slash
       * [see also](https://github.com/perwendel/spark/issues/1026)
       */
      url = encodeURIComponent(url as string).replace(/%2F/g, '%252F').replace(/%3F/g, '%253F');
      return this.httpClient.post(`${this._baseURL}/${roleName}/permission/${url}`, {});
    } else {
      return this.httpClient.post(`${this._baseURL}/${roleName}/permissions`, url);
    }
  }

  revokePermissionToRole(roleName: string, url: string | string[]): Observable<any> {
    if (!_.isArray(url)) {
      url = encodeURIComponent(url as string).replace(/%2F/g, '%252F');
      return this.httpClient.delete(`${this._baseURL}/${roleName}/permission/${url}`);
    } else {
      return this.httpClient.delete(`${this._baseURL}/${roleName}/permissions`, {
        params: {
          pid: (url as string[]).map(u => u.replace(/%2F/g, '%252F'))
        }
      });
    }
  }

}
